<template>
  <div >
    <el-card class="box-card">
        <div class="product">
            <div class="img">
                <img :src="product.bigImg" />
            </div>
            <div class="title">{{product.name}}</div>
            <div class="price">￥{{product.price}}/{{product.unit}}</div>
            <div class="buy" @click="fn_order">
                <span>立即购买 &gt;</span>
            </div>
        </div>
    </el-card>
  </div>
</template>

<script>
import img from '@/assets/banner.png'
export default {
  name: 'Home',
  data : function(){
    return {
        product : {}
    }
  },
  created() {
      this.product =  JSON.parse(window.localStorage.getItem('product')||'{}')
  },
  methods : {
      fn_order(obj){
          this.$router.push({
              name : 'Order'
          })
      }
  }
}
</script>

<style>
.product{
    text-align: left;
    line-height: 1.5;
    position: relative;
}
.product .img img{
    width: 100%;
}
.product .title{
    
}
.product .price{
    color: #BD82A6;
}
.product .buy{
    position: absolute;
    right: 0;
    bottom: 0;
    color: #fff;
}
.product .buy span{
    padding: 5px 8px;
    background: #000000;
    border-radius: 2px;
    cursor: pointer;

}
</style>



// WEBPACK FOOTER //
// src/pages/Buy.vue